export default "__VITE_ASSET__Bb1YC3mm__"